
import router from "@/mixins/router";
import propertyFormat from "@/mixins/propertyFormat";

export default {
  name: "SimplePropertyList",
  props: {
    propertiesList: {
      default: []
    },
  },
  mixins: [
    router,
    propertyFormat,
  ],
  methods: {
    getMaxGuests(property) {
      return property.unit_categories.reduce((totalGuests, unitCategory) => {
        return unitCategory.type === 1 ? totalGuests + parseInt(unitCategory.max_occupation) : totalGuests;
      }, 0);
    },
    openGallery(images) {
      this.isOpenGallery = true;
      this.propertyImages = images;
    },
    unitHasData(unitCategory) {
      let unitData = []
      unitData.push(
        unitCategory.room_features_bathrooms,
        unitCategory.room_features_bedrooms,
        unitCategory.room_features_beds,
        unitCategory.room_features_size
      )

      return !unitData.every(element => element === null)
    },
  },
};
